export default {
  state: {
    loading: false,
    error: null,
    success: null,
    link: null,
    settings: {
      enabled_authorize: null,
      enabled_authorize_merchandise: null,
      enabled_paypal: null,
      enabled_paypa_merchandise: null,
      enabled_bitpay: null,
      enabled_points: null,
      max_packages_combine: null,
      show_announcement: null,
      pay_instantly: null,
      announcement_text: null,
      sms_notification_fee: [],
      addition_photo_fee: [],
      minimum_sum_for_instantly_pay: [],
      split_rate: [],
      currencies: [],
      statuses: [],
      formTypes: [],
      shipmentMethods: [],
      invoiceTypes: [],
      userTypes: [],
    },
    fieldError: null
  },
  mutations: {
    setLink(state, payload) {
      state.link = payload
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setError(state, payload) {
      state.error = payload
    },
    clearError(state) {
      state.error = null
    },
    setSuccess(state, payload) {
      state.success = payload
    },
    clearSuccess(state) {
      state.success = null
    },
    setSettings(state, payload) {
      state.settings = payload
    },
    setFieldError(state, payload) {
      state.fieldError = payload
    },
    clearFieldError(state) {
      state.fieldError = null
    }
  },
  actions: {
    setLink({commit}, payload) {
      commit('setLink', payload)
    },
    setLoading({commit}, payload) {
      commit('setLoading', payload)
    },
    setError({commit}, payload) {
      commit('setError', payload)
    },
    setSuccess({commit}, payload) {
      commit('setSuccess', payload)
    },
    clearError({commit}) {
      commit('clearError')
    },
    clearSuccess({commit}) {
      commit('clearSuccess')
    },
    setSettings({commit}, payload) {
      commit('setSettings', payload)
    }
  },
  getters: {
    link(state) {
      return state.link
    },
    loading(state) {
      return state.loading
    },
    error(state) {
      return state.error
    },
    success(state) {
      return state.success
    },
    getSettings(state) {
      return state.settings
    }
  }
}
